const FILTERS = {};

export const registerFilter = (key, method) => { FILTERS[key] = method; };

export const getFilter = (key) => (FILTERS[key]);
